import classNames from 'clsx';
import React from 'react';
import type { MdComponentIndexProps } from '../type';
import styles from './Tip.module.less';

function transformBoolean(val: any) {
  if (typeof val === 'boolean') {
    return val;
  }
  if (val === 'true') {
    return true;
  }
  if (val === 'false') {
    return false;
  }
  return undefined;
}

export function MarkdownTipGood(
  props: React.PropsWithChildren<
    {
      border?: boolean;
    } & MdComponentIndexProps
  >,
) {
  const border = transformBoolean(props.border) ?? true;
  return (
    <div
      className={classNames(styles.TipContainer, styles.TipContainerShowLine)}
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <div className="flex items-center pl-1">
        <div className="relative mr-4 w-4 h-4 rounded-full text-white flex items-center justify-center">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              scale: 'calc(24 / 20)',
              marginBottom: 2,
            }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 2C4.47715 2 0 6.47715 0 12C0 17.5228 4.47715 22 10 22C15.5228 22 20 17.5228 20 12C20 6.47715 15.5228 2 10 2ZM14.7337 9.91555C15.0888 9.56053 15.0888 8.98493 14.7337 8.6299C14.3787 8.27488 13.8031 8.27488 13.4481 8.6299L8.63636 13.4416L6.55192 11.3572C6.19689 11.0022 5.62129 11.0022 5.26627 11.3572C4.91124 11.7122 4.91124 12.2878 5.26627 12.6428L7.99354 15.3701C8.34856 15.7251 8.92417 15.7251 9.27919 15.3701L14.7337 9.91555Z"
              fill="var(--ui-green-6)"
            />
          </svg>
          {border ? (
            <div
              className={classNames('absolute top-full mt-1 rounded-full', styles.TipLine)}
              style={{
                width: 1,
                backgroundColor: `var(--ui-green-2)`,
                left: `0.46875rem`,
                height: `calc(var(--markdown-x-component-gap) + 0px)`, // 16px
                top: `calc(var(--markdown-x-component-gap) + 1px)`, // 16px + 1px
              }}
            />
          ) : null}
        </div>
        <div className="m-0 flex-1 text-base font-semibold text-slate-900 dark:text-slate-200 markdown-child-root">
          {props.children}
        </div>
      </div>
    </div>
  );
}

MarkdownTipGood.attributes = ['border'] as string[];
